import React, { useCallback } from 'react';
import { Map } from '@vis.gl/react-google-maps';
import { GOOGLE_MAP_ID } from '../../configs';

export const GoogleMap = ({
  center = { lat: 0, lng: 0 },
  zoom = 10,
  mapId = GOOGLE_MAP_ID,
  onMapLoad,
  controls = {
    mapTypeControl: false,
    rotateControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    zoomControl: true,
  },
  className = '',
  style = {},
  children,
  ...restProps
}) => {
  const handleMapLoad = useCallback((mapInstance) => {
    if (onMapLoad) {
      onMapLoad(mapInstance);
    }
  }, [onMapLoad]);

  // Default to 100% width and height if not specified
  const mapStyle = {
    width: '100%',
    height: '100%',
    ...style,
  };

  return (
    <Map
      defaultCenter={center}
      defaultZoom={zoom}
      mapId={mapId}
      onLoad={handleMapLoad}
      mapTypeControl={controls.mapTypeControl}
      rotateControl={controls.rotateControl}
      streetViewControl={controls.streetViewControl}
      fullscreenControl={controls.fullscreenControl}
      zoomControl={controls.zoomControl}
      className={className}
      style={mapStyle}
      {...restProps}
    >
      {children}
    </Map>
  );
};
